import { WorkStationConfig } from 'typings/brands'
import customerSupport from './customerSupport'

const workStationConfig: WorkStationConfig = {
  expiryPageCSRNumber: {
    proxNo: customerSupport.contactUsProx,
    brcNo: customerSupport.contactUsBrc
  }
}

export default workStationConfig
